import { render } from "./ContractPage.vue?vue&type=template&id=189f0e82"
import script from "./ContractPage.vue?vue&type=script&lang=js"
export * from "./ContractPage.vue?vue&type=script&lang=js"

import "./ContractPage.vue?vue&type=style&index=0&id=189f0e82&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__